/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { DDoSStats } from "../../models/d-do-s-stats";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetSubscriptionDdosTraffic$Params {
  subscription_id: string;
  ip_version: number;
  start?: number | null;
  end?: number | null;
  step?: number;
  raw?: boolean;
}

export function getSubscriptionDdosTraffic(
  http: HttpClient,
  rootUrl: string,
  params: GetSubscriptionDdosTraffic$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<DDoSStats>>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionDdosTraffic.PATH, "get");
  if (params) {
    rb.path("subscription_id", params.subscription_id, {});
    rb.query("ip_version", params.ip_version, {});
    rb.query("start", params.start, {});
    rb.query("end", params.end, {});
    rb.query("step", params.step, {});
    rb.query("raw", params.raw, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DDoSStats>>;
    }),
  );
}

getSubscriptionDdosTraffic.PATH = "/dashboard/stats/ddos/{subscription_id}";
